import AdminDashboard from "../components/dashboard/Index";

export default function DashboardPage() {
  return <AdminDashboard />;
}
